module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "green darken-4",
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Audience Insight")])], 1), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n          Unlock Audience Insights.\n          Join our 1 year membership program for just $4.29 per year!\n        ")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34f01ebc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/DashboardComponents/AudienceInsightPreview.vue
// module id = 2074
// module chunks = 0